import React, { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';

const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('pc_install_dismissed');
    if (dismissed) return;

    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    if (isStandalone) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);

    if (isIOS && !isStandalone) {
      setTimeout(() => { setIosHint(true); setVisible(true); }, 4000);
    }
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const choice = await deferred.userChoice;
    if (choice.outcome === 'accepted') localStorage.setItem('pc_install_dismissed', '1');
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem('pc_install_dismissed', '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-[900] max-w-[420px] w-[calc(100%-1.5rem)] slide-up">
      <div className="bg-[#1c1c1c] text-[#f8f6f1] rounded-2xl p-4 shadow-2xl flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-[#2a2a2a] flex items-center justify-center shrink-0">
          <Download size={16} className="text-[#d4cfc4]"/>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[13.5px] font-medium">Instalar PriceCapture</p>
          {iosHint ? (
            <p className="text-[11.5px] text-[#a8a397] mt-1 leading-relaxed">Toca <span className="text-[#f8f6f1] font-medium">Compartir</span> y luego <span className="text-[#f8f6f1] font-medium">Añadir a pantalla de inicio</span> para usarla sin internet.</p>
          ) : (
            <p className="text-[11.5px] text-[#a8a397] mt-0.5">Acceso rápido y funciona sin internet</p>
          )}
          {!iosHint && (
            <button onClick={install} className="mt-2 px-3 h-7 bg-[#f8f6f1] text-[#1c1c1c] rounded-full text-[11.5px] font-medium">Instalar app</button>
          )}
        </div>
        <button onClick={dismiss} className="text-[#a8a397] hover:text-[#f8f6f1] shrink-0"><X size={16}/></button>
      </div>
    </div>
  );
};

export default InstallPrompt;
